// extracted by mini-css-extract-plugin
export var alignCenter = "_ba-d";
export var bannerShown = "_ba-6";
export var buttonContent = "_ba-0";
export var cardList = "_ba-1";
export var centerContent = "_ba-2";
export var chevron = "_ba-3";
export var closePanelButton = "_ba-k";
export var conversationContextContainer = "_ba-l";
export var conversationDetailContainer = "_ba-4";
export var detailWrapper = "_ba-7";
export var dropdownButton = "_ba-e";
export var dropdownTitle = "_ba-9";
export var fullHeight = "_ba-5";
export var hidden = "_ba-a";
export var icon = "_ba-b";
export var mergeSuggestionWrapper = "_ba-m";
export var panel = "_ba-i";
export var portalButtonsWrapper = "_ba-c";
export var right = "_ba-j";
export var tableSummaryContainer = "_ba-8";
export var tableSummaryHeader = "_ba-g";
export var threeDotsButton = "_ba-f";
export var wide = "_ba-h";